import MarketplaceListView from './MarketplaceListView.html';
import { MarketplaceListController } from './MarketplaceListController';
const MarketplaceListComponent = {
    template: MarketplaceListView,
    controllerAs: '$ctrl',
    controller: MarketplaceListController,
    bindings: {
        templates: '<',
        planSelect: '=',
        size: '@?',
        onSearchBots: '&?',
        planAccount: '<',
    },
};
export default MarketplaceListComponent;
